// extracted by mini-css-extract-plugin
export default {"advertCardFooter":"c-a_gP","advertCardFooter__row":"c-a_gQ","advertCardFooter__name":"c-a_gR","advertCardFooter__price":"c-a_gS","advertCardFooter__age":"c-a_gT"};